import styles from "./index.module.css";
const SubTitle = (props) => {
  return <p className={styles["sub-title"]}>{props.children}</p>;
};
export default SubTitle;
